import { NgModule } from '@angular/core';
import { SharedModule } from '@app/shared';
import { PackagesVersionsModule } from './packages/packages-versions/packages-versions.module';
import { PackagesModule } from './packages/packages.module';
import {ScriptRepositoryModule} from './scriptRepository-ang7/scriptRepository.module'
import { PackageManagerComponent } from './packageManager-ang7';
import {processesHoverViewModule} from '@app/authorized/project/pipeline/processesHoverView-ang7/processesHoverView.module'

@NgModule({
    imports: [
        SharedModule,
        PackagesModule,
        PackagesVersionsModule,
        ScriptRepositoryModule,
        processesHoverViewModule
    ],
    declarations: [PackageManagerComponent],
    entryComponents: [PackageManagerComponent],
    exports: [PackageManagerComponent]
})
export class PackageManagerModule {
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/authorized/project/packageManager/package-manager.module.ts